export const DASHBOARD_BASE_PATH = "/dashboard";
export const DASHBOARD_HOME_PATH = "/dashboard/home";
export const DASHBOARD_INSIGHTS_BASE_PATH = "/dashboard/insights";
export const DASHBOARD_RECOMMENDATIONS_PATH = "/dashboard/recommendations";
export const DASHBOARD_RECOMMENDATION_DETAILS_PATH = "/dashboard/recommendations/:recoId";
export const DASHBOARD_OFFERS_PATH = "/dashboard/specialOffers";
export const DASHBOARD_PROFILE_PATH = "/dashboard/profile";
export const DASHBOARD_SURVEY_PATH = "/dashboard/survey";
export const DASHBOARD_CALCULATOR_PATH = "/dashboard/whatIfCalc";
export const DASHBOARD_SETTINGS_PATH = "/dashboard/settingsPreferences";
export const DASHBOARD_FAQS_PATH = "/dashboard/faqs";
export const FEEDBACK_PAGE_PATH = "/feedback";
export const PREFERENCES_BASE_PATH = "/preferences";
export const STANDALONE_PAGE_PATH = "/:destination?";
export const DISAGG101_BASE_PATH = "/disagg101";
export const SSO_PATH = '/sso';
export const WIDGET_BASE_PATH = '/widget';
export const PUBLIC_WIDGET_BASE_PATH = '/public/widget';
export const DASHBOARD_SOLAR_PATH = "/dashboard/solar";
export const DASHBOARD_HOME_ADVISOR_PATH = '/dashboard/home-advisor';
export const HER_PATH = '/homeEnergyReport';
export const DASHBOARD_MARKETPLACE_PATH = '/dashboard/products';
export const DASHBOARD_DECARBONIZATION_PATH = '/dashboard/decarbonization';
export const CONTACT_INFO_PATH = '/contact-info';
export const CONTRACT_INFO_PATH = '/contract-info';
export const ALERT_TYPE_PATH = '/alert-type';
export const ALERT_TYPE_ELECTRIC_PATH = '/alert-type/electric';
export const ALERT_TYPE_GAS_PATH = '/alert-type/gas';
export const SETTINGS_PATH = '/settings';

export const INSIGHTS_PATH = {
  USAGE: `${DASHBOARD_INSIGHTS_BASE_PATH}/usage`,
  MONTHLY_SUMMARY: `${DASHBOARD_INSIGHTS_BASE_PATH}/monthly-summary`,
  SIMILAR_HOMES: `${DASHBOARD_INSIGHTS_BASE_PATH}/similar-homes`,
  BILL_ANALYSIS: `${DASHBOARD_INSIGHTS_BASE_PATH}/bill-analysis`,
  BILL_PROJECTION: `${DASHBOARD_INSIGHTS_BASE_PATH}/bill-projection`,
  RATE_PLAN_OPTIONS: `${DASHBOARD_INSIGHTS_BASE_PATH}/rate-plans`,
  TIME_OF_USE_ANALYSIS: `${DASHBOARD_INSIGHTS_BASE_PATH}/time-of-use-analysis`,
  ACTIVITY_MAP: `${DASHBOARD_INSIGHTS_BASE_PATH}/activity-map`
};

export const WIDGET_PATHS = {
  PREFERENCES: `${WIDGET_BASE_PATH}/preferences`,
  MARKETPLACE: `${PUBLIC_WIDGET_BASE_PATH}/marketplace`,
  RECO_DETAILS: `${PUBLIC_WIDGET_BASE_PATH}/recommendations/:recoId`
};